import React from "react";

import { LinkFieldToOther } from "../../../components/fields/LinkField";
import { NotifObjectType } from "../../../entities";

const sourceByObjectType = {
	[NotifObjectType.general]: "",
	[NotifObjectType.order]: "orders",
	[NotifObjectType.deviation]: "deviations",
};

export const ObjectField = (props) => {
	if (!props.record) return null;
	return (
		<LinkFieldToOther
			source="object_id"
			otherResource={sourceByObjectType[props.record.object_type]}
			otherIdProp="object_id"
			{...props}
		/>
	);
};
